/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RESOURCE_PAGE_ACTIONS } from '../actions';
import { ResourceService } from '../services';
import { catchError, of, switchMap, tap } from 'rxjs';
import {
  downloadDocumentPdf,
  Resource,
  watchVideoLink,
} from '@data-access/resource';

@Injectable()
export class ResourceEffects {
  private readonly _actions$ = inject(Actions); 
  private readonly _resourceService = inject(ResourceService);  
  
  loadResources$ = createEffect(() =>
    this._actions$.pipe(
      ofType(RESOURCE_PAGE_ACTIONS.loadResources),
      switchMap(() =>
        this._resourceService.getResources().pipe(
          switchMap((response) => {
            return [
              RESOURCE_PAGE_ACTIONS.onLoadResourceSuccess({
                resource: response as Resource[],
              }),
            ];
          }),
          catchError((error: Error) =>
            of(
              RESOURCE_PAGE_ACTIONS.onLoadResourceFailure({
                error: error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  downloadResource$ = createEffect(() =>
    this._actions$.pipe(
      ofType(RESOURCE_PAGE_ACTIONS.downloadResource),
      switchMap(({ uuid, mime_type, conditionalProps }) =>
        this._resourceService.downloadResource(uuid).pipe(
          switchMap((response) => {
            return [
              RESOURCE_PAGE_ACTIONS.onDownloadResourceSuccess({
                conditionalProps,
                downloadString: response,
                mime_type,
              }),
            ];
          }),
          catchError((error: Error) =>
            of(RESOURCE_PAGE_ACTIONS.onDownloadResourceFailure({ error })),
          ),
        ),
      ),
    ),
  );

  onDownloadResourceSuccess$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(RESOURCE_PAGE_ACTIONS.onDownloadResourceSuccess),
        tap(({ mime_type, downloadString, conditionalProps }) =>
          mime_type === 'video/mp4'
            ? watchVideoLink(downloadString, {
                ...conditionalProps!,
              })
            : downloadDocumentPdf(downloadString),
        ),
      ),
    {
      dispatch: false,
    },
  );
}
